import { render, staticRenderFns } from "./ProcessSlider.vue?vue&type=template&id=490960cf&scoped=true"
import script from "./ProcessSlider.vue?vue&type=script&lang=js"
export * from "./ProcessSlider.vue?vue&type=script&lang=js"
import style0 from "./ProcessSlider.vue?vue&type=style&index=0&id=490960cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490960cf",
  null
  
)

export default component.exports